export default function getIndexOfSubstring(string, substring) {
  return string.toLowerCase().replace(/ё/g, 'е').indexOf(substring.toLowerCase().replace(/ё/g, 'е'));
}